import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../lib/auth";

const ProtectedRoute = ({ children }) => {
  const { user, checking } = useAuth();
  const location = useLocation();
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-light" data-testid="auth-checking">
        <div className="text-brand-medium text-sm tracking-[0.28em] uppercase">Loading…</div>
      </div>
    );
  }
  if (!user) {
    const loginPath = location.pathname.startsWith("/estateos")
      ? "/estateos/login"
      : "/admin/login";
    return <Navigate to={loginPath} replace state={{ from: location }} />;
  }
  return children;
};

export default ProtectedRoute;
